import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ListPage from './Pages/List/Index';
import ShowPage from './Pages/Show/Index';

import Context from './Context';

import Main from './Main';

export default function Index() {
  return (
    <Context>
      <Main />
    </Context>
  );
}
